
import { Options, prop, Vue } from "vue-class-component";
import ImagePreviewAuth from "@/app/ui/components/image-preview-auth/index.vue";
import parsingLinkGcpToAws from "@/app/infrastructures/misc/common-library/ParsingLinkGcpToAws";
import needsAuth from "@/app/infrastructures/misc/common-library/NeedsAuth";
import { getToken } from "@/app/infrastructures/misc/Cookies";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { ActivityController } from "@/app/ui/controllers/ActivityController";
import { SendActivityApiRequest } from "@/data/payload/api/ActivityApiRequest";

class Props {
  name = prop<string>({ default: "", type: String });
  url = prop<string>({ default: "", type: String });
  maxLength = prop<number>({ default: 50, type: Number });
  error = prop<boolean>({ default: false, type: Boolean });
  errorCaption = prop<string>({ default: "", type: String });
  linked = prop<boolean>({ default: false, type: Boolean });
  img = prop<boolean>({ default: false, type: Boolean });
  bordered = prop<boolean>({ default: true, type: Boolean });
  dash = prop<boolean>({ default: true, type: Boolean });
  attachmentClassName = prop<string>({ default: "", type: String });

  // NEW: show/hide Preview button
  showPreview = prop<boolean>({ default: true, type: Boolean });

  activityHeader = prop<string>({ default: "", type: String });
}

@Options({
  name: "DownloadAttachmentPreview",
  components: { ImagePreviewAuth }
})
export default class DownloadAttachmentPreview extends Vue.with(Props) {
  photoPreview = false;
  photo = "";

  get isPdf(): boolean {
    const fileExt = this.url
      ?.split(".")
      .pop()
      ?.toLowerCase();
    return fileExt === "pdf";
  }

  get photoPreviews() {
    return [{ image: this.url, url: this.url }];
  }

  shortNameFile(name: string, length: number) {
    const shortName = `${name
      .replaceAll("sign?path=", "")
      .slice(0, length)}...`;
    return name.length > length ? shortName : name.replaceAll("sign?path=", "");
  }

  private extractFileExtension(url: string): string | undefined {
    if (!url) return undefined;
    try {
      const urlParts = url.split('?');
      if (urlParts.length > 1) {
        const queryString = urlParts[1];
        const params = new URLSearchParams(queryString);
        const pathValue = params.get("path");

        if (pathValue) {
          const pathParts = pathValue.split('.');
          const pathExt = pathParts.pop();
          if (pathExt) {
            // console.log("cek pathExt:", pathExt);
            return pathExt.toLowerCase();
          }
        }
      }
      const urlPartsBase = url.split('.');
      const baseExt = urlPartsBase.pop()?.split('?')[0];

      if (baseExt) {
        // console.log("cek baseExt:", baseExt);
        return baseExt.toLowerCase();
      }
      return undefined;

    } catch (error) {
      console.error("Error extracting file extension:", error);
      return url.split('.').pop()?.toLowerCase();
    }
  }

  onPreview(url: string, _fileName: string) {
    if (!url) return;
    ActivityController.sendActivity(
      new SendActivityApiRequest({
        after: url,
        before: url,
        activityHeader: this.activityHeader
      })
    );
    const ext = this.extractFileExtension(url);
    if (ext === "pdf") this.previewPdf(url);
    else this.previewImage(url);
  }

  previewImage(url: string) {
    this.photo = url;
    this.photoPreview = true;
  }

  async previewPdf(url: string) {
    if (!url) return;
    try {
      const parsedUrl = parsingLinkGcpToAws(url);
      const init: RequestInit = {};
      if (needsAuth(url)) {
        MainAppController.showLoading();
        const headers = new Headers();
        headers.append("authorization", `Bearer ${getToken()}`);
        init.headers = headers;
      }
      const res = await fetch(parsedUrl, init);
      if (!res.ok) {
        MainAppController.closeLoading();
        throw new Error(`HTTP ${res.status}`);
      }
      const blob = await res.blob();
      const pdfBlob = new Blob([blob], { type: "application/pdf" });
      const objUrl = window.URL.createObjectURL(pdfBlob);
      MainAppController.closeLoading();
      window.open(objUrl, "_blank");
      setTimeout(() => URL.revokeObjectURL(objUrl), 60000);
    } catch (e) {
      MainAppController.closeLoading();
      console.error("Failed to open PDF:", e);
    }
  }
}
